/* Tysk katalog for locale-support-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('de', {
  'nav.support': 'Support',
  'navhelp.support': 'Sieh dir deine eingereichten Supportanfragen an und verfolge sie.',
  'route.support': 'Support',
  'support.title': 'Support',
  'support.contact': 'Support kontaktieren',
  'support.close': 'Schließen',
  'support.send': 'Senden',
  'support.sending': 'Wird gesendet…',
  'support.editor.toolbar': 'Nachrichtenformatierung',
  'support.editor.bold': 'Fett',
  'support.editor.italic': 'Kursiv',
  'support.editor.underline': 'Unterstrichen',
  'support.editor.bullets': 'Aufzählung',
  'support.editor.numbered': 'Nummerierte Liste',
  'support.editor.list': 'Liste',
  'support.editor.link': 'Link',
  'support.editor.linkPrompt': 'Füge einen http://- oder https://-Link ein',
  'support.editor.image': 'Bild',
  'support.editor.screenshot': 'Screenshot',
  'support.editor.screenshotLabel': 'Screenshot der aktuellen Ansicht anhängen',
  'support.editor.capturing': 'Screenshot wird erstellt…',
  'support.editor.pendingImages': 'Bilder bereit zum Senden',
  'support.editor.removeImage': 'Bild entfernen',
  'support.editor.openImage': 'Bild öffnen',
  'support.editor.optimizing': 'Bilder werden optimiert…',
  'support.retry': 'Erneut versuchen',
  'support.back': 'Zurück zu den Supportanfragen',
  'support.category': 'Kategorie',
  'support.category.feil': 'Fehler / etwas funktioniert nicht',
  'support.category.fakturering': 'Abrechnung und Zahlung',
  'support.category.sporsmal': 'Allgemeine Frage',
  'support.category.annet': 'Sonstiges',
  'support.subject': 'Betreff',
  'support.subject.placeholder': 'Kurze Beschreibung des Anliegens',
  'support.message': 'Nachricht',
  'support.message.placeholder': 'Beschreibe, was passiert, gern mit Details',
  'support.sent.title': 'Die Supportanfrage wurde gesendet',
  'support.sent.text': 'Wir haben {id} erhalten und melden uns so schnell wie möglich.',
  'support.new.title': 'Neue Supportanfrage',
  'support.new.action': 'Neue Anfrage',
  'support.filter.label': 'Supportanfragen filtern',
  'support.filter.all': 'Alle',
  'support.filter.open': 'Offen',
  'support.filter.closed': 'Geschlossen',
  'support.table.ticket': 'Anfrage',
  'support.table.category': 'Kategorie',
  'support.table.sent': 'Gesendet',
  'support.table.lastReply': 'Letzte Antwort',
  'support.lastReply.you': 'Du',
  'support.lastReply.support': 'Support',
  'support.table.status': 'Status',
  'support.status.open': 'Offen',
  'support.status.closed': 'Geschlossen',
  'support.opened': 'Geöffnet am {date}',
  'support.closeTicket': 'Als geschlossen markieren',
  'support.table.actions': 'Aktionen',
  'support.delete.rowAction': 'Löschen',
  'support.delete.rowLabel': 'Anfrage {{id}} löschen',
  'support.delete.action': 'Anfrage löschen',
  'support.delete.title': 'Anfrage löschen?',
  'support.delete.confirm': 'Löschen',
  'support.delete.text': 'Die Anfrage wird aus deiner Liste entfernt, und ihre Nachrichten sind für dich nicht mehr verfügbar.',
  'support.delete.done': 'Die Anfrage wurde gelöscht.',
  'support.error.delete': 'Die Anfrage konnte nicht gelöscht werden. Versuche es erneut.',
  'support.reopen.action': 'Wieder öffnen',
  'support.reopen.title': 'Supportanfrage wieder öffnen?',
  'support.reopen.confirm': 'Trotzdem öffnen',
  'support.reopen.text': 'Öffne die Anfrage nur wieder, wenn es um dasselbe Problem geht wie ursprünglich. Handelt es sich um ein neues Anliegen, erstelle lieber eine neue Supportanfrage.',
  'support.you': 'Du',
  'support.agent': 'Support',
  'support.reply.placeholder': 'Setze das Gespräch fort – schreibe eine Nachricht an den Support',
  'support.closed.note': 'Diese Anfrage ist geschlossen. Du kannst den Verlauf sehen, aber keine weiteren Nachrichten senden.',
  'support.empty.title': 'Noch keine Supportanfragen',
  'support.empty.filterTitle': 'Keine Anfragen in diesem Filter',
  'support.empty.text': 'Anfragen, die du über die Support-Schaltfläche einreichst, erscheinen hier.',
  'support.loading.list': 'Supportanfragen werden geladen…',
  'support.loading.thread': 'Gespräch wird geladen…',
  'support.error.required': 'Gib sowohl Betreff als auch Nachricht ein.',
  'support.error.noBusiness': 'Wähle ein Unternehmen, bevor du den Support kontaktierst.',
  'support.error.create': 'Die Supportanfrage konnte nicht gesendet werden. Versuche es erneut.',
  'support.error.list': 'Die Supportanfragen konnten nicht geladen werden.',
  'support.error.thread': 'Das Gespräch konnte nicht geladen werden.',
  'support.error.reply': 'Die Nachricht konnte nicht gesendet werden. Versuche es erneut.',
  'support.error.status': 'Der Status konnte nicht aktualisiert werden.',
  'support.error.link': 'Gib einen gültigen http://- oder https://-Link ein.',
  'support.error.imageType': 'Verwende Bilder im Format JPEG, PNG, GIF oder WebP.',
  'support.error.imageSourceSize': 'Jedes Originalbild darf höchstens 20 MB groß sein.',
  'support.error.imageSourceTotal': 'Die Originalbilder dürfen pro Auswahl insgesamt höchstens 40 MB groß sein.',
  'support.error.imageCount': 'Du kannst bis zu vier Bilder anhängen.',
  'support.error.imageSize': 'Ein Bild ist nach der Optimierung immer noch größer als 5 MB.',
  'support.error.imageTotal': 'Optimierte Bilder dürfen pro Nachricht insgesamt höchstens 10 MB groß sein.',
  'support.error.imageOptimize': 'Das Bild konnte nicht optimiert werden. Versuche ein kleineres Bild.',
  'support.error.screenshot': 'Der Screenshot konnte nicht erstellt werden. Versuche es erneut oder hänge ein Bild manuell an.',
  'support.error.imagesUnavailable': 'Das Senden von Bildern erfordert den aktualisierten Supportdienst. Lade die Seite neu und versuche es erneut.',
  'support.error.requestTimedOut': 'Der Supportdienst hat nicht geantwortet. Versuche es erneut.',
  'support.page.tickets': 'Supportanfragen',
  'support.page.articles': 'Artikel',
  'support.articles.back': 'Zurück zu den Artikeln',
  'support.articles.search.label': 'Hilfeartikel durchsuchen',
  'support.articles.categories': 'Kategorien',
  'support.articles.results': 'Gefundene Artikel: {count}',
  'support.articles.empty.title': 'Keine Artikel gefunden',
  'support.articles.empty.text': 'Versuche einen anderen Suchbegriff oder wähle eine andere Kategorie.',
  'support.articles.clear': 'Suche und Filter zurücksetzen',
  'support.pages.label': 'Supportseite wählen',
  'support.articles.search.placeholder': 'Hilfeartikel durchsuchen',
  'support.articles.count.one': '{count} Artikel',
  'support.articles.count.other': '{count} Artikel',
  'support.articles.resultsTitle': 'Suchergebnisse',
  'err.nativeValidation.backend-support.1': 'Ungültige Antwort beim Löschen der Supportanfrage.',
});
